/* eslint-disable func-names */
import * as yup from 'yup';
import emojiRegex from 'emoji-regex';
import { RequiredNumberSchema } from 'yup/lib/number';
import { RequiredStringSchema } from 'yup/lib/string';
import { AnyObject, Maybe } from 'yup/lib/types';

yup.setLocale({
  string: {
    email: 'FORM.VALID.EMAIL_FORMAT',
    max: ({ max }: { max: number }) => ({ key: 'FORM.VALID.MAX_LENGTH', value: { max } }),
    min: ({ min }: { min: number }) => ({ key: 'FORM.VALID.MIN_LENGTH', value: { min } }),
  },
  number: {
    max: ({ max }: { max: number }) => ({ key: 'FORM.VALID.MAX_LENGTH', value: { max } }),
    min: ({ min }: { min: number }) => ({ key: 'FORM.VALID.MIN_LENGTH', value: { min } }),
  },
  mixed: {
    required: 'FORM.VALID.IS_EMPTY',
    notType: 'FORM.VALID.ONLY_NUMBER',
  },
});

yup.addMethod<yup.StringSchema>(yup.string, 'emptyAsUndefined', function () {
  return this.transform((value) => (value.trim() || undefined));
});

yup.addMethod<yup.StringSchema>(yup.string, 'noSpecialCharacter', function () {
  return this.test('noSpecialCharacter', 'FORM.VALID.SPECIAL_CHARACTER', (value) => {
    if (value) {
      const emojiReg = emojiRegex();
      return /^((?!~|`|!|@|#|\$|%|\^|&|\*|=|\+|\{|\}|\||\\|"|;|'|<|>|\?|,|\/|:|\(|\)|\[|\]).)*$/.test(value) && !emojiReg.test(value);
    }
    return true;
  });
});

yup.addMethod<yup.StringSchema>(yup.string, 'password', function () {
  return this.test('password', 'FORM.VALID.PASSWORD_FORMAT', (value) => {
    if (value) {
      // eslint-disable-next-line max-len
      return (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~!@#$%^&*()-_=+[{}\]\\|;:'",<.>/?])[A-Za-z\d`~!@#$%^&*()-_=+[{}\]\\|;:'",<.>/?]{8,64}$/g).test(value);
    }
    return true;
  });
});

yup.addMethod<yup.StringSchema>(yup.string, 'phone', function () {
  return this.test('phone', 'FORM.VALID.PHONE_FORMAT', (value) => {
    if (value) {
      return /^[0-9-#()+]*$/.test(value);
    }
    return true;
  });
});

yup.addMethod<yup.NumberSchema>(yup.number, 'emptyAsUndefined', function () {
  return this.transform((value, originalValue) => String(originalValue)?.trim() ? value : undefined);
});

yup.addMethod<yup.NumberSchema>(yup.number, 'between', function (min: number, max: number, float: number) {
  return this.test('between', { key: 'FORM.VALID.BETWEEN_NUMBER', value: { min, max, float } }, (value) => {
    if (value) {
      if (value < min) return false;
      if (value > max) return false;
      if (!new RegExp(`^[0-9]+(.[0-9]{${float}})?$`, 'g').test(value.toString())) return false;
      // if (value.toString().split('.')[1]?.length > float) return false;
    }
    return true;
  });
});

declare module 'yup' {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType,
  > extends yup.BaseSchema<TType, TContext, TOut> {
    emptyAsUndefined(): StringSchema<TType, TContext>;
    noSpecialCharacter(): RequiredStringSchema<TType, TContext>;
    password(): RequiredStringSchema<TType, TContext>;
    phone(): RequiredStringSchema<TType, TContext>;
  }

  interface NumberSchema<
    TType extends Maybe<number> = number | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType,
  > extends yup.BaseSchema<TType, TContext, TOut> {
    emptyAsUndefined(): NumberSchema<TType, TContext>;
    between(min: number, max: number, float: number): RequiredNumberSchema<TType, TContext>;
  }
}
